import React from 'react';

const SvgBj = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BJ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="BJ_svg__d" d="M0 9.333h28V20H0z" />
      <filter
        x="-5.4%"
        y="-14.1%"
        width="110.7%"
        height="128.1%"
        filterUnits="objectBoundingBox"
        id="BJ_svg__c"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <path id="BJ_svg__f" d="M0 0h28v9.333H0z" />
      <filter
        x="-5.4%"
        y="-16.1%"
        width="110.7%"
        height="132.1%"
        filterUnits="objectBoundingBox"
        id="BJ_svg__e"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BJ_svg__b" fill="#fff">
        <use xlinkHref="#BJ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BJ_svg__a" />
      <g mask="url(#BJ_svg__b)">
        <use fill="#000" filter="url(#BJ_svg__c)" xlinkHref="#BJ_svg__d" />
        <use fill="#F12641" xlinkHref="#BJ_svg__d" />
      </g>
      <g mask="url(#BJ_svg__b)">
        <use fill="#000" filter="url(#BJ_svg__e)" xlinkHref="#BJ_svg__f" />
        <use fill="#FFD648" xlinkHref="#BJ_svg__f" />
      </g>
      <path fill="#17A668" mask="url(#BJ_svg__b)" d="M0 0h10.667v20H0z" />
    </g>
  </svg>
);

export default SvgBj;
